


































import Vue from 'vue';
import { BFormCheckbox } from 'bootstrap-vue';
import { mapActions } from 'vuex';
import { sendRequest } from '../../utils/client/client';

import { ModalSize } from '@/components/zen_modal/types';
import GenericCard from './GenericCard.vue';

export default Vue.extend({
  name: 'CloseCard',
  components: {
    GenericCard,
    BFormCheckbox,
  },
  props: {
    bulkCount: {
      type: Number,
      default: 0,
    },
    axiosRequest: {
      type: Object,
      required: true,
    },
    redirectUrl: {
      type: String,
      default: '',
    },
    objectType: {
      type: String,
      default: '',
    },
    objectTitle: {
      type: String,
      default: 'object',
    },
    italicizeObjectTitle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      confirmed: false,
    };
  },
  computed: {
    insideSPA(): boolean {
      return !!this.$router;
    },
    titleCopy(): string {
      if (this.bulkCount > 0) {
        return `${this.objectType}`;
      } else {
        return this.formatObjectTitle ? `"${this.objectTitle}"` : this.objectTitle;
      }
    },
    formatObjectTitle(): boolean {
      return this.italicizeObjectTitle && this.objectTitle !== 'object';
    },
    descriptionCopy(): string {
      if (this.objectType.toLowerCase().includes('custom attribute')) {
        return this.objectType;
      }

      return this.bulkCount > 1 || !this.objectType.length ? 'object' : this.objectType;
    },
    checkboxCopy(): string {
      if (this.objectType.toLowerCase().includes('custom attribute')) {
        return `${this.bulkCount > 1 ? 'All ' : ''}${this.objectType}`;
      }

      return this.bulkCount > 1 || !this.objectType.length ? 'All objects' : this.objectType;
    },
  },
  created() {
    this.$emit('updateConfig', { size: ModalSize.Small });
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
    }),
    async confirmClosing() {
      try {
        // Disable confirmation button
        this.loading = true;

        // Send request
        const data = await sendRequest(this.axiosRequest);

        let type, message;
        if (!data.failed_ids.length) {
          type = 'success';
          message = 'Success! Your questionnaires have been closed and cannot be reopened.';
        } else if (!data.closed_ids.length) {
          type = 'error';
          message = 'Oops! Something went wrong and your questionnaires were not closed';
        } else {
          type = 'warning';
          const totalIds = data.closed_ids.length + data.failed_ids.length;
          message = `Heads up! ${data.closed_ids.length} out of ${totalIds} selected questionnaires have been closed - completed questionnaires cannot be closed.`;
        }

        if (this.insideSPA) {
          this.$store.dispatch('modals/confirm');
          this.showAlert({
            type: type,
            message: message,
          });
        } else {
          window.GGRC.Notify({
            type: type,
            message: message,
          });
        }

        // Redirect or close and refresh page
        setTimeout(() => {
          if (this.redirectUrl) {
            this.redirect();
          } else {
            if (!this.insideSPA) {
              window.GGRC.zenModal.$emit('reloadPage');
            }
            this.$emit('close');
          }
        }, 1000);
      } catch (error) {
        if (this.insideSPA) {
          this.showAlert({
            type: 'error',
            message: 'Oops, something went wrong.',
          });
        } else {
          window.GGRC.Notify({
            type: 'error',
            message: 'Oops, something went wrong.',
          });
        }
        this.loading = true;
      }
    },
    redirect() {
      document.location.href = this.redirectUrl;
    },
  },
});
